import styled from 'styled-components'
import PropTypes from 'prop-types'

export const SmallWrapper = styled.div`
  height: 56px;
  padding: 17px 0;
  color: ${props => props.theme.colors.greyscale.white};
  text-align: center;
  background-color: ${props => props.theme.colors.greyscale.subtle};
`

export const MediumWrapper = styled.div`
  position: relative;
  color: ${({theme}) => theme.colors.primary.base};
  font-weight: bold;
  white-space: nowrap;
  flex-shrink: 0;
  padding: 5px 5px 5px 0;
  
  .multiLanguage_flyout {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background: ${({theme}) => theme.colors.greyscale.white};
    z-index: 3;
    box-shadow: 0 6px 25px -6px rgba(78,95,116,0.5);
    border-radius: 6px;
    
    button {
      display: block;
      padding: 10px 15px;
      min-width: 150px;
      text-align: left;
      
      &:not(:last-child) {
        border-bottom: 1px solid ${props => props.theme.colors.greyscale.light};
      }
    }
    
    &:before {
      position: absolute;
      display: block;
      content: '';
      top: -7px;
      left: 10px;
      border: 0 solid transparent;
      border-width: 0 12px 10px 12px;
      border-bottom-color: white;
    }
  }
  
  &:hover {
    cursor: pointer;
  }
  
  &:hover .multiLanguage_flyout {
    display: block;
  }
  
  i {
    display: inline-block;
    width: 24px;
    vertical-align: middle;
    margin-top: -3px;
  }
`

export const LanguageButton = styled.button`
  text-decoration: none;
  padding: ${({withPadding}) => (withPadding ? '0 15px' : '0')};
  font-size: ${({size, theme}) => (size === 'small' ? theme.typography.fontSize.fs2 : theme.typography.fontSize.fs3)};
  line-height:  ${({size, theme}) => (size === 'small' ? theme.typography.lineHeight.fs2 : theme.typography.lineHeight.fs3)};
  font-weight: ${({bold}) => (bold ? 'bold' : 'normal')};
  cursor: pointer;
  background: transparent;
  border: none;
  color: ${({theme, type}) => theme.colors[type].base};
  &:hover, &:hover:visited {
    color: ${({theme, type}) => theme.colors[type].dark}
  }
`

LanguageButton.props = {
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  size: PropTypes.oneOf(['small', 'default']),
  bold: PropTypes.bool,
  withPadding: PropTypes.bool,
  ellipsis: PropTypes.bool
}

LanguageButton.defaultProps = {
  type: 'primary',
  size: 'small',
  bold: true,
  withPadding: true,
  ellipsis: false
}
